import i18n from '@/i18n/i18n';
import { Lang } from '@/types/common/lang';
/**
 * Получает текущий выбранный язык пользователя через i18n.
 * Возвращает поддерживаемый язык (en или ru), по умолчанию en.
 */
export function getCurrentLanguage() {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
        return Lang.RU;
    }
    return Lang.EN;
}
